module.exports = __webpack_public_path__ + "img/95ne.30fd033a.svg";